import type { CosmosApp } from "../engine/CosmosApp.ts";

const HOME = "__home__";

/** Histórico de navegação (voltar/avançar), estilo browser.
 *  A seleção real acontece no engine; aqui só registramos a trilha. */
export class Navigator {
  private stack: string[] = [];
  private idx = -1;
  private suppress = false;
  onChange?: (canBack: boolean, canForward: boolean) => void;

  constructor(private cosmos: CosmosApp) {}

  /** navegação iniciada pelo usuário (clique, chip, busca, favorito) */
  navigate(id: string) { this.cosmos.selectById(id); }
  home() { this.cosmos.reset(); }

  /** chamado pelo hook onSelect do engine (toda seleção passa por aqui) */
  onSelected(id: string | null) {
    const key = id ?? HOME;
    if (this.suppress) { this.emit(); return; }
    if (this.stack[this.idx] === key) { this.emit(); return; }
    this.stack = this.stack.slice(0, this.idx + 1);
    this.stack.push(key);
    if (this.stack.length > 120) this.stack.shift();
    this.idx = this.stack.length - 1;
    this.emit();
  }

  back() { if (this.idx > 0) { this.idx--; this.go(); } }
  forward() { if (this.idx < this.stack.length - 1) { this.idx++; this.go(); } }

  private go() {
    const key = this.stack[this.idx];
    this.suppress = true;
    if (key === HOME || !this.cosmos.hasNode(key)) this.cosmos.reset();
    else this.cosmos.selectById(key);
    this.suppress = false;
    this.emit();
  }
  private emit() { this.onChange?.(this.idx > 0, this.idx < this.stack.length - 1); }
}
